export const info = {
  invTrans: {
    noRecords: 'There are no transactions to display, please apply a different filter.',
    noRecordsTitle: 'Nothing here yet!',
    active: 'Active',
    inactive: 'Inactive',
    deleted: 'Deleted',
  },
};
